import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth.service';

export const onboardedGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const isOnboarded = authService.isOnboarded();

  const orgUrlTree = router.parseUrl('/org/onboarding');

  return isOnboarded ? true : orgUrlTree;
};
